import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterM = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M16.04 8.00037V16.4004H14.66V10.4124L12.104 14.6364H11.936L9.38 10.4004V16.4004H8V8.00037H9.488L12.02 12.2004L14.564 8.00037H16.04Z" }),
});

export { IconCapitalLetterM };
